import { Location } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, SubscriptionLike } from 'rxjs';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { CampaignService } from 'src/app/_services/campaign.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { BulkRevealModalComponent } from 'src/app/bulk-reveal-modal/bulk-reveal-modal.component';
import { ArchiveCandidateModalComponent } from '../archive-candidate-modal/archive-candidate-modal.component';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { BulkEmailCampaignComponent } from '../bulk-email-campaign/bulk-email-campaign.component';
declare const clevertap;
import { AiSourcingPollingService } from 'src/app/_services/ai-sourcing-polling.service';
import * as _ from 'underscore';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-ai-sourcing-profiles',
    templateUrl: './ai-sourcing-profiles.component.html',
    styleUrls: ['./ai-sourcing-profiles.component.scss'],
    standalone: false
})
export class AiSourcingProfilesComponent implements OnInit {
  isReview: boolean = false;
  isShortlisted: boolean = false;
  isArchieved: boolean = false;
  isActivity: boolean = false;
  tabtoShow: string;
  selected: boolean = false;
  selectedAllCandidates: any[] = [];
  projectNumber: string;
  successMessage: string = '';
  errorMessage: string = '';
  projectDetails: any;
  campaign_input = new UntypedFormControl(null, [Validators.required]);
  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  isLoadingEmailCampaignApi: boolean = false;
  selectedCampaign: any;
  emailFoundCount: number;
  campaignList: any;
  @Output() refreshCurrentView: EventEmitter<any> = new EventEmitter();
  totalCandidatesCount: number = 0;
  start: number = 0;
  end: number = 0;
  subscriptionsLike: SubscriptionLike[] = [];
  projectCount: any = {};
  shortlistCount: number = 0;
  archiveCount: number = 0;
  unactionedCount: number = 0;
  showAlert: boolean = false;
  currentTab: string = '';
  emailCampaignResponse: any = [];
  subscriptions: Array<Subscription> = [];
  pollingSub: Subscription;
  tab: string;
  perPageCandidate: any[] = [];
  /**
   * To show ai sourcing progress for a project
   */
  progress: number = 0;
  aiSourcingStatus: string;

  circleRadius = 12;

  // circumference = 2 * PI * r
  circumference = 2 * Math.PI * this.circleRadius;
  isAISourcingEnabled: boolean = false;
    @ViewChild('accessManagementModal') accessManagementModal: TemplateRef<any>;
      @ViewChild('addToEmailCampaignWithViewCampaign') addToEmailCampaignWithViewCampaign: TemplateRef<any>;
  campaignName: string = '';


  constructor(
    private router: Router,
    private aiSourcingService: AiSourcingService,
    private locationService: Location,
    private modalService: NgbModal,
    private emailCampaignService: CampaignService,
    private _localStorageService: LocalStorageService,
    private candidateservice: CandidateService,
    private personSearchService: PersonSearchService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private filterDataHandlerService: FilterDataHandlerService,
    private pollingService: AiSourcingPollingService
  ) {

    const tab = window.location.pathname;
    if (tab.includes('/ai-sourcing/ai-sourcing-profiles/review')) {
      this.isReview = true;
      this.isShortlisted = false;
      this.isArchieved = false;
      this.isActivity = false;
      this.tab = 'toReview';

    } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/archive')) {
      this.isArchieved = true;
      this.isReview = false;
      this.isShortlisted = false;
      this.isActivity = false;
            this.tab = 'archieved';

    } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/shortlist')) {
      this.isShortlisted = true;
      this.isReview = false;
      this.isArchieved = false;
      this.isActivity = false;
      this.tab = 'shortlist';
    } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/activity')) {
      this.isActivity = true;
      this.isShortlisted = false;
      this.isReview = false;
      this.isArchieved = false;
    } else {
      this.isReview = true;
      this.isShortlisted = false;
      this.isArchieved = false;
      this.isActivity = false;
    }

    const locationSub = this.locationService.subscribe((p: any) => {
      const tab = p.url;
      if (tab.includes('/ai-sourcing/ai-sourcing-profiles/review')) {
        this.isReview = true;
        this.isShortlisted = false;
        this.isArchieved = false;
        this.isActivity = false;

      } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/archive')) {
        this.isArchieved = true;
        this.isReview = false;
        this.isShortlisted = false;
        this.isActivity = false;
      } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/shortlist')) {
        this.isShortlisted = true;
        this.isReview = false;
        this.isArchieved = false;
        this.isActivity = false;
      } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/activity')) {
        this.isActivity = true;
        this.isShortlisted = false;
        this.isReview = false;
        this.isArchieved = false;
      } else {
        this.isReview = true;
        this.isShortlisted = false;
        this.isArchieved = false;
        this.isActivity = false;
      }

    });
    this.subscriptionsLike.push(locationSub);
  }

  get strokeDashOffset() {
    // progress 0-100, convert to stroke offset
    return this.circumference * (1 - this.progress / 100);
  }

  ngOnInit() {
    this.projectNumber = window.location.pathname?.split('/')[4];
    const getCandidateSubscription = this.aiSourcingService.getCandidateEvent.subscribe((res: any) => { this.getAllCandidates(res) });
    this.subscriptions.push(getCandidateSubscription);
    const getCandidatePagination = this.aiSourcingService.getCandidateListEvent.subscribe((res: any) => { this.getcandidatepagination(res) });
    this.subscriptions.push(getCandidatePagination);
    this.getTabActive()
    this.getProjectDetails();
    this.isAISourcingEnabled = this._localStorageService.getItem('autopilotslotaccess') == '1' ? true : false;

    const projectCountSubscription = this.aiSourcingHandlerService.getProjectCountEvent.subscribe((res: any) => {
      this.selected = false;
      if (res.tab == 'review') {
        this.currentTab = res.tab;
        this.projectCount.unactioned = res.count;
      } else if (res.tab == 'shortlist') {
        this.currentTab = res.tab;

        this.projectCount.shortlisted = res.count;
      } else if (res.tab == 'archive') {
        this.currentTab = res.tab;

        this.projectCount.archive = res.count;
      }
        if(!res.filterApplied)
      this.getProjectDetails();

    });
    this.subscriptions.push(projectCountSubscription);
  }

  onTabChange(type: string) {
    this.isReview = false;
    this.isShortlisted = false;
    this.isArchieved = false;
    this.isActivity = false;
    this.selected = false;
    this.showAlert = false;
    this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab });
    this.selectedAllCandidates = [];
    switch (type) {
      case 'toReview':
        this.showAlert = false;
        this.isReview = true;
        this.tab = type;
        this.aiSourcingHandlerService.setClearFilterEvent({ status: 'clear', from: 'tabChange' });
             /**
     * Click on To Review Tab
     */
         const evaluationParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber

        }
        clevertap.event.push("Autopilot-Review Tab Click",evaluationParams);
        // this.getProjectDetails();
        this.router.navigate(['/ai-sourcing/ai-sourcing-profiles/review/' + this.projectNumber]);


        break;
      case 'shortlist':
        this.tab = type;
        this.isShortlisted = true;
        this.aiSourcingHandlerService.setClearFilterEvent({ status: 'clear', from: 'tabChange' });
        //  this.getProjectDetails();
       /**
     * Click on To Shortlist Tab
     */
         const shortlistParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber

        }
        clevertap.event.push("Autopilot-Shortlist Tab Click",shortlistParams);
        this.router.navigate(['/ai-sourcing/ai-sourcing-profiles/shortlist/' + this.projectNumber]);
        break;
      case 'archieved':
        this.showAlert = false;
        this.tab = type;
        this.isArchieved = true;
        this.aiSourcingHandlerService.setClearFilterEvent({ status: 'clear', from: 'tabChange' });
        //  this.getProjectDetails();
          /**
            * Click on To Shortlist Tab
          */
         const archiveParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber

        }
        clevertap.event.push("Autopilot-Archive Tab Click",archiveParams);
        this.router.navigate(['/ai-sourcing/ai-sourcing-profiles/archive/' + this.projectNumber]);
        break;
      case 'activity':
        this.showAlert = false;
        this.isActivity = true;
        this.aiSourcingHandlerService.setClearFilterEvent({ status: 'clear', from: 'tabChange' });
        this.router.navigate(['/ai-sourcing/ai-sourcing-profiles/activity/' + this.projectNumber]);
        break;
      default:
        break;
    }

  }

  selectAll(event: any) {
    const value = (event.target as HTMLInputElement) && (event.target as HTMLInputElement).checked ? true : false;
    if (value) {
      this.selected = true;
      this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: true, tab: this.tab });
    } else {
      this.selected = false;
      this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab });
    }
  }

  getAllCandidates(res: Array<Object>) {
    this.selectedAllCandidates = [];
    this.selectedAllCandidates = _.uniq(this.selectedAllCandidates.concat(res), 'id');
    const selectedIds = new Set(this.selectedAllCandidates.map((c: any) => c.id));
    const selectedCountOnPage = this.perPageCandidate.filter((candidate: any) => selectedIds.has(candidate.id)).length;

    if (selectedCountOnPage == this.perPageCandidate?.length) {
      this.selected = true;
    } else {
      this.selected = false;
    }

    if (this.selectedAllCandidates.length > 0) {
      this.showAlert = true;
    } else {
      this.showAlert = false;
    }
  }

  changeCandidateStatus(type) {
    if (type == 'archive') {
      const modalRef = this.modalService.open(ArchiveCandidateModalComponent, { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.data = this.selectedAllCandidates;
      modalRef.componentInstance.projectNumber = this.projectNumber;
      modalRef.componentInstance.archivetype = "Bulk";
      modalRef.componentInstance.calledFrom = "BulkAction";
      modalRef.componentInstance.passEntry.subscribe((res: any) => {
        if (res === "success") {
          this.successMessage = 'Candidate successfully archived';
          setTimeout(() => {
            this.successMessage = '';
          }, 5000);
          if (this.isReview) {
            this.aiSourcingService.emitRefreshListEvent({ refresh: true });
            this.selectedAllCandidates = [];
            this.selected = false;
            this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false,tab: this.tab });
            this.showAlert = false;
          } else if (this.isShortlisted) {
            this.aiSourcingService.emitRefreshListEvent({ refresh: true });
            this.selectedAllCandidates = [];
            this.selected = false;
            this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab });
            this.showAlert = false;

          }
        } else {
          this.errorMessage = 'Error occurred while archiving candidate';
          setTimeout(() => {
            this.errorMessage = '';
          }, 5000);
        }
        /**
          * Click for Bulk archive candidates
          */
         const archiveParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": this.isReview ? "Review Page": "Shortlist Page"
        }
        clevertap.event.push("Bulk Archive Candidates",archiveParams);

      });

    } else {
      const payload = {
        projectnumber: this.projectNumber,
        status: type,
        elasticids: this.selectedAllCandidates.map(candidate => candidate.id),
      }

      this.aiSourcingService.changeCandidateStatus(payload).subscribe((res: any) => {
        if (res.status === 'success') {
          this.successMessage = 'Candidate successfully shortlisted';
          setTimeout(() => {
            this.successMessage = '';
          }, 5000);
          if (this.isReview) {
            this.aiSourcingService.emitRefreshListEvent({ refresh: true });
            this.selectedAllCandidates = [];
            this.selected = false;
            this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab });
            this.showAlert = false;
          } else if (this.isArchieved) {
            this.aiSourcingService.emitRefreshListEvent({ refresh: true });
            this.selectedAllCandidates = [];
            this.selected = false;
            this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab });
            this.showAlert = false;
          }
        } else {
          this.errorMessage = 'Error occurred while changing candidate status';
          setTimeout(() => {
            this.errorMessage = '';
          }, 5000);
        }

         /**
          * Click for Bulk shortlist candidates
          */
         const archiveParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": this.isReview ? "Review Page": "Archoive Page"
        }
        clevertap.event.push("Bulk Shortlist Candidates",archiveParams);
      }, (err)=>{
        if(err.status === 422){
            this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
            this.router.navigate([`/ai-sourcing/project-list`]);
        }
      })
    }

  }

  getProjectDetails() {
    this.aiSourcingService.getProjectDetails(this.projectNumber).subscribe((res: any) => {
      this.projectDetails = res.data;
      this.aiSourcingStatus = res.data.aisourcingstatus;
      if(res.data.aisourcingstatus === 'started' || res.data.aisourcingstatus === 'pending'){
        // this.pollingSub = this.pollingService.startPolling(this.projectNumber).subscribe(res => {
        //   this.progress = res.data.progress !== null ? res.data.progress : this.progress;
        //   if(this.progress == 100){
        //     this.aiSourcingHandlerService.notifyProgressCompleted();
        //   }
        // });
      }
      if (this.currentTab == 'review') {
        this.projectCount.shortlisted = this.projectDetails?.sourcedcandidatecount?.shortlisted || 0;
        this.projectCount.archive = this.projectDetails?.sourcedcandidatecount?.archive || 0;
      } else if (this.currentTab == 'shortlist') {
        this.projectCount.unactioned = this.projectDetails?.sourcedcandidatecount?.unactioned || 0;
        this.projectCount.archive = this.projectDetails?.sourcedcandidatecount?.archive || 0;
      } else if (this.currentTab == 'archive') {
        this.projectCount.unactioned = this.projectDetails?.sourcedcandidatecount?.unactioned || 0;
        this.projectCount.shortlisted = this.projectDetails?.sourcedcandidatecount?.shortlisted || 0;
      } else {
         this.projectCount.shortlisted = this.projectDetails?.sourcedcandidatecount?.shortlisted || 0;
        this.projectCount.archive = this.projectDetails?.sourcedcandidatecount?.archive || 0;
        this.projectCount.unactioned = this.projectDetails?.sourcedcandidatecount?.unactioned || 0;
      }
      this.aiSourcingHandlerService.setProjectDetails(this.projectDetails);
    }, (err)=>{
      if(err.status === 422) {
         if (err.error.errorCode == 'PROJECT_ACCESS_DENIED') {
            this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
            this.router.navigate([`/ai-sourcing/project-list`]);
        }
      } else if(err.status === 403) {
         if (err.error.errorCode == 'AUTOPILOT_ACCESS_DENIED') {
          this.aiSourcingHandlerService.setDisplayPageEvent('landing-page');
          this.router.navigate([`/ai-sourcing`]);
        }
      }
    })
  }

  /**
   * Method to use redirect to the project details page
   */
  goToDetailsPage(type) {
    if(type == 'project-details'){
    this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
    this.router.navigate([`/ai-sourcing/project-details/${this.projectNumber}`]);
    }else if(type == 'autopilot-criteria'){
      this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
      this.router.navigate([`/ai-sourcing/project-details/${this.projectNumber}/autopilot-evaluation-criteria`]);
    }else if(type == 'autopilot-activity'){
      this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
      this.router.navigate([`/ai-sourcing/project-details/${this.projectNumber}/autopilot-activity`]);
    }

  };

  redirectToInsights() {
    this.aiSourcingHandlerService.setDisplayPageEvent('project-insights-summary');
     /**
     * Click on Insights
     */
         const evaluationParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber

        }
        clevertap.event.push("Autopilot-View Project Insights",evaluationParams);
    this.router.navigate([`/ai-sourcing/ai-sourcing-insights/${this.projectNumber}`]);
  }

  openAddToEmailCampaign(data) {

    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  // Add this function to handle the selection from the typeahead
  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }

  async addToEmailCampaign() {
    this.campaign_input.markAllAsTouched();

    this.isLoadingEmailCampaignApi = true;
    let totalTarget = 0;
    let unsubscribedCandidateCount = 0;
    if (this.campaign_input.valid && this.selectedCampaign) {
      const campaign_id = this.selectedCampaign.campaign_id;
      let payloadArray = this.selectedAllCandidates?.length && this.selectedAllCandidates.map(x => {
        totalTarget++;
        if (x?.is_unsubscribed) {
          unsubscribedCandidateCount++;
          return
        }
        return {
          firstname: x.first_name,
          target_name: x.full_name,
          target_id: null,
          target_meta: JSON.stringify({
            "candidatenumber": x.candidatenumber && x.candidatenumber.length ? x.candidatenumber : null,
            "elastic_id": x.id,
            "title": x.job_title,
          }),

          //elastic || else send 0
          target_email: x.existingContactDetails && x.existingContactDetails.length ?
            this.extractPreferredEmail(x.existingContactDetails) : null,
          is_active: true,
          created_on: new Date().toISOString(),
          updated_on: new Date().toISOString(),
          projectnumber: this.projectNumber,
        };
      }).filter(Boolean);
      const updatedPayloadArray = (payloadArray?.length) ? payloadArray.filter(x => x) : [];
      this.emailFoundCount = 0;
      updatedPayloadArray.forEach(element => {
        if (element.target_email)
          this.emailFoundCount++;
      }
      );
      const payloadWithCandidateNumber = updatedPayloadArray.filter(
        (x) => JSON.parse(x.target_meta || '{}')?.candidatenumber
      );
      const payloadWithoutCandidateNumber = updatedPayloadArray.filter(
        (x) => !JSON.parse(x.target_meta || '{}')?.candidatenumber
      );
      let finalPayload = payloadWithCandidateNumber;
      if (
        payloadWithCandidateNumber &&
        payloadWithCandidateNumber.length > 0 &&
        payloadWithoutCandidateNumber &&
        payloadWithoutCandidateNumber.length === 0
      ) {
      } else if (
        payloadWithoutCandidateNumber &&
        payloadWithoutCandidateNumber.length > 0
      ) {
        const elasticid = payloadWithoutCandidateNumber.map(
          (x) => JSON.parse(x.target_meta).elastic_id
        );
        const payload ={
          elasticids: elasticid,
          projectnumber: this.projectNumber
        }



        const res = await this.aiSourcingService.aiSourcingMigrate(payload).toPromise();
        payloadWithoutCandidateNumber.forEach((x) => {
          const parsedElasticId = x.target_meta ? JSON.parse(x.target_meta).elastic_id: null;
          if (res && res.data && res.data.length) {
            res.data.map((item) => {
              if (item.elasticId === parsedElasticId) {
                let tempMeta = JSON.parse(x.target_meta);
                tempMeta.candidatenumber = item.candidatenumber;
                x.target_meta = JSON.stringify(tempMeta);
              }
              x.target_id = null;
            });
          }
        });
        finalPayload = finalPayload.concat(payloadWithoutCandidateNumber);
      }
      finalPayload = finalPayload.filter(x => (JSON.parse(x?.target_meta)?.candidatenumber));

      const elasticid = finalPayload.map(
        (x) => JSON.parse(x.target_meta).elastic_id
      );

      //If final payload has length 0, and we have list of unbubscribed candidates then show toast,
      // No candidades were added to email campaign
      if (unsubscribedCandidateCount > 0 && finalPayload.length === 0) {
        this.closeActiveModal();
        this.toastmessage("Unsubscribed from Email Campaign", 'error');
        return;
      }
      this.campaignName = this.campaign_input.value;
      finalPayload?.length > 0 && this.emailCampaignService.createTarget(campaign_id, finalPayload).subscribe((res: any) => {
        if (res.status == 'success') {
          this.isLoadingEmailCampaignApi = false;
          if (res.data && res.data.length) {
            this.emailCampaignResponse = res.data;
            this.addEmailCampaignActivity(res.data);
            this.closeActiveModal();

            const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);
            if (this.emailFoundCount !== finalPayload.length) {

              // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
              const bulkRevealPayLoad = {
                enrichedFrom: "ai-sourcing",
                candidates: [],
                campaign_id: campaign_id,
                projectnumber: this.projectNumber
              }

              res.data.map((arr) => {
                if (!arr?.target_email) {
                  bulkRevealPayLoad.candidates.push(
                    {
                      elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                      campaign_target_id: arr.campaign_target_id,
                      candidatenumber: arr.target_meta ? JSON.parse(arr.target_meta || '{}')?.candidatenumber: null
                    }
                  );
                }
              })

              this.openEmailCampaignModal(campaign_id, totalTarget, bulkRevealPayLoad, this.emailCampaignResponse);
            }
            else {
              this.closeActiveModal()
              if (unsubscribedCandidateCount) {
                this.toastmessage("Unsubscribed from Email Campaign", 'error');
              }
              else this.toastmessage("Candidates already present in selected campaign", 'error')
            }

            this.selectedAllCandidates = [];
            this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab });
            this.showAlert = false;
            this.selected = false;
          } else {
            this.closeActiveModal();
              this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab });
            this.showAlert = false;
            this.selected = false;
            this.toastmessage("Candidates already present in selected campaign", 'error');
          }
        }
          else if (res.status == 'failure') {
            this.closeActiveModal()
            this.toastmessage("candidate addition failed", "error");
          }

      }, (error: HttpErrorResponse) => {
            this.isLoadingEmailCampaignApi = false;
            if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
              const remainingTargets = error.error.remainingTargets;
              this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
            } else {
              this.toastmessage("Something went wrong", "error");
            }
            this.closeActiveModal();
          });
    } else {
      this.isLoadingEmailCampaignApi = false;
    }
  }
  getContactDetails(candidateid, type) {
    return new Promise((resolve, reject) => {
      let data = {
        "usernumber": this._localStorageService.getItem('usernumber'),
        "candidatenumber": candidateid,
      };

      this.candidateservice.getContactDetails(data).subscribe(
        (res: any) => {
          if (res.status === 'success') {
            let email = null;
            if (type == 'FirstPersonal') {
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == 'personal')?.contactdetail;
              if (email == null)
                email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == 'professional')?.contactdetail;
            }
            else if (type == 'FirstProfessional') {
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == 'professional')?.contactdetail;
              if (email == null)
                email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == 'personal')?.contactdetail;
            }
            else {
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == type)?.contactdetail;
            }
            if (email) {
              resolve(email);
            } else {
              // reject("Primary email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }

  openDetailsModal(campaign_id, payload, emailsFound, total_target, unsubscribedCandidateCount) {
    const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.unsubscribedCandidateCount = unsubscribedCandidateCount;
    modalRef.componentInstance.calledFor = 'email-campaign';
  }

  closeActiveModal() {
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.modalService.dismissAll()
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  /**
* Extract target email based on preference
* @param details existing contact detail object
* @returns
*/
  extractPreferredEmail(details) {
    let emailPref = this.selectedCampaign['email_pref']
    let personalPref_email = [];
    let professionalPref_email = [];
    let targetEmailFound = '';
    const existingContactDetails = details?.filter(x => x.type === 'email');
    if (existingContactDetails && existingContactDetails.length) {

      personalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'personal')
      professionalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'professional')

      switch (emailPref) {
        case 1: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : '';
          break;
        case 2: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
          break;
        case 3: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
          break;
        case 4: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : personalPref_email.length ? personalPref_email[0].contactdetail : '';
          break;
      }
    }
    return targetEmailFound;
  }


  getCandidateActivityInBulk(elastic_id, type) {
    this.personSearchService.getCandidateActivityInBulk(elastic_id).subscribe((result: any) => {
      if (result && result.status == "success") {
        const bulkCandidateActivity = result.message
        this.selectedAllCandidates.forEach(candidate => {
          let availableData = bulkCandidateActivity.find(y => y.elastic_id == candidate.idinindex)
          if (availableData) {
            candidate['lastcandidateactivity'] = [availableData]
            if (type === 'email-campaign') {
              if (candidate['emailcampaigncount'] && candidate['emailcampaigncount'] >= 1) {
                candidate['emailcampaigncount'] = candidate['emailcampaigncount'] + 1
              } else {
                candidate['emailcampaigncount'] = 1;
              }
            }
          }
        })
      }
    });
  }

  onTypeAheadSearch(event: string): void {
    const query = event;
    this.emailCampaignService.getCampaigns({ campaign_name: query, created_by: this._localStorageService.getItem('userdata').userid, 'status[]': [1, 2] }).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

  getTabActive() {
    const tab = window.location.pathname;
    if (tab.includes('/ai-sourcing/ai-sourcing-profiles/review')) {
      this.tabtoShow = 'review';
      this.isReview = true;
    } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/shortlist')) {
      this.tabtoShow = 'shortlist';
      this.isShortlisted = true;
    } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/archieved')) {
      this.tabtoShow = 'archieved';
      this.isArchieved = true;
    } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/activity')) {
      this.tabtoShow = 'activity';
      this.isActivity = true;
    }
  }

  getcandidatepagination(res) {
    this.perPageCandidate = res?.results || [];
    const selectedIds = new Set(this.selectedAllCandidates.map((c: any) => c.id));
    const selectedCountOnPage = this.perPageCandidate.filter((candidate: any) => selectedIds.has(candidate.id)).length;
    if (selectedCountOnPage == this.perPageCandidate?.length) {
      this.selected = true;
    } else {
      this.selected = false;
    }
    this.totalCandidatesCount = res?.candidatecount;
    if (this.totalCandidatesCount > 50)
      this.end = 50;
    else
      this.end = this.totalCandidatesCount;
  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  closeAlert() {
    this.showAlert = false;
    this.selected = false;
    this.selectedAllCandidates = [];
    this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab, clearAll: true });
  }

  openEmailCampaignModal(campaign_id, totalTarget, payload, reponse) {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(BulkEmailCampaignComponent, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.totalTarget = totalTarget;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.responseLength = reponse.length;
    modalRef.componentInstance.type = "Bulk";

     /**
          * Click for Bulk archive candidates
          */
         const archiveParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": "Shortlist Page"
        }
        clevertap.event.push("Bulk Add To Email Candidates",archiveParams);

  }

  getProjectCount(tab?: string) {
    this.projectCount = {
      unactioned: this.projectDetails?.sourcedcandidatecount?.unactioned || 0,
      shortlisted: this.projectDetails?.shortlistedcandidatecount?.shortlisted || 0,
      archive: this.projectDetails?.archivedcandidatecount?.archive || 0
    }

  }

    addEmailCampaignActivity(data) {
    const payload = {
      "projectnumber": this.projectNumber,
      "action": "addtoemailcampaign",
      "elasticids": data.map(x => x.target_meta ? JSON.parse(x.target_meta).elastic_id : null),
      "activitydata": {
        "campaignname": this.selectedCampaign.campaign_name,
      }
    }

    this.aiSourcingService.aiSourcingEmailCampaignActivity(payload).subscribe((res: any) => {
      if (res.status === 'success') {
        console.log('Email campaign activity tracked successfully');
      } else {
        console.error('Error occurred while tracking email campaign activity');
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
    }
  }

  /**
   *
   * @param string
   * @returns
   */
  chipCleanUp(value: any) {
    const normalize = (item: any): string => {
      if (item === null || item === undefined) return '';

      let text = '';
      if (typeof item === 'string') {
        text = item;
      } else if (typeof item === 'object') {
        text = item.chipkey || item.key || item.value || '';
      } else {
        text = String(item);
      }

      return text.includes('.aisearch') ? text.split('.aisearch')[0] : text;
    };

    if (Array.isArray(value)) {
      return value.map((item: any) => normalize(item)).filter(Boolean).join(', ');
    }

    if (typeof value === 'string') {
      return value.split(',').map((res: string) => normalize(res.trim())).filter(Boolean).join(', ');
    }

    return normalize(value);
  };

  get tabClickAccess() {
    if(this.projectDetails?.status === 'inactive') {
      return true;
    }
  }

  /**
   * Export profiles in bulk based on selected candidates. The file will be sent to user's email as Excel.
   */
  bulkExport() {
    let tabname = '';
    if(this.isReview) {
      tabname = 'unactioned';
    } else if(this.isShortlisted) {
      tabname = 'shortlisted';
    } else if(this.isArchieved) {
      tabname = 'archive';
    }
    const payload = {
      projectnumber: this.projectNumber,
      elasticids: this.selectedAllCandidates.map(candidate => candidate.id),
      tabname: tabname
    }
    this.aiSourcingService.bulkExport(payload).subscribe((res: any) => {
      if (res.body) {
        this.toastmessage("Your request has been received. The profiles file will be sent to your email shortly.", "success");
        this.selectedAllCandidates = [];
        this.aiSourcingService.emitSelectAllCandidateEvent({ selectAll: false, tab: this.tab });
        this.showAlert = false;
        this.selected = false;
      }
    }, (err) => {
      this.toastmessage("Error occurred while processing your request. Please try again later.", "error");
    })
  }

  redirectToEmailCampaign(campaign_id){
    this.router.navigateByUrl(`email-campaign/target-listing/${campaign_id}`);
  }

}
